export default __webpack_public_path__ + "static/media/burst-sm-1.567a8b8e.mp3";